import { ErrorKey } from '../app-active-error/ErrorKey';
import { setError } from '../store/error/action-creators';
import { Tracker } from '../store/tracking/action-creators';
export const handleBlogSettingsError = (error, dispatch) => {
  dispatch(Tracker.signupInteraction('blog-settings-endpoint-failure'));
  dispatch(setError(ErrorKey.MissingBlogIdeasGeneratorScopesError));
};